import React, { useState } from "react";

function Carousel({ children, onSlideChange }) {
  const slides = React.Children.toArray(children);
  const [activeIndex, setActiveIndex] = useState(0);
  const total = slides.length;

  const goTo = (index) => {
    const nextIndex = (index + total) % total;
    setActiveIndex(nextIndex);

    const child = slides[nextIndex];
    const key = child.props?.["data-key"];

    onSlideChange?.(key ?? nextIndex);
  };

  const prev = () => goTo(activeIndex - 1);
  const next = () => goTo(activeIndex + 1);

  return (
    <div className="carousel slide text-center">
      {/* Indicators */}
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={
              index === activeIndex
                ? "active carousel-action-indicator"
                : "carousel-action-indicator"
            }
          />
        ))}
      </div>

      {/* Slides */}
      <div className="carousel-inner">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-item ${index === activeIndex ? "active" : ""}`}
            style={{ display: index === activeIndex ? "block" : "none" }}
          >
            {slide}
          </div>
        ))}
      </div>

      {/* Controls */}
      <button
        className="carousel-control-prev bg-transparent carousel-action-buttons"
        type="button"
        onClick={prev}
      >
        <span className="carousel-control-prev-icon" />
      </button>

      <button
        className="carousel-control-next bg-transparent carousel-action-buttons"
        type="button"
        onClick={next}
      >
        <span className="carousel-control-next-icon" />
      </button>
    </div>
  );
}

export default Carousel;
